import Chart from "chart.js";
import { Doughnut } from "vue-chartjs";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "chartjs-adapter-moment";
import { RATING_CHART_COLOR } from "@/config/rating-chart-colors";

export default {
  extends: Doughnut,
  props: {
    ratingDistribution: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chartData: [],
      options: {
        plugins: {
          datalabels: {
            ...ChartDataLabels,
            align: "start",
            anchor: "start",
            offset: -1,
            display: "auto",
            color: "rgba(54,60,86,0.7)",
            font: {
              family: "Montserrat",
              size: 14,
              weight: 500
            },
            formatter: (value, context) => {
              const total = context.dataset.data.reduce((sum, val) => {
                sum += val;
                return sum;
              }, 0);
              const percentage = ((value / total) * 100).toFixed(1);
              return value ? parseFloat(percentage) + "%" : "";
            }
          }
        },
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        cutoutPercentage: 80,
        labelFontFamily: "Montserrat",
        labelFontStyle: "bold",
        tooltips: {
          bodyFontFamily: "Montserrat",
          bodyFontStyle: "bold",
          callbacks: {
            label: (tooltipItem, data) =>
              data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
          }
        }
      }
    };
  },
  watch: {
    ratingDistribution() {
      this.setChartData();
      this.createChart();
    }
  },
  beforeDestroy() {
    Chart.plugins.unregister(ChartDataLabels);
  },
  mounted() {
    this.setChartData();
    this.createChart();
  },
  methods: {
    createChart() {
      this.addPlugin(ChartDataLabels);
      this.renderChart(
        {
          datasets: [
            {
              backgroundColor: [
                RATING_CHART_COLOR.RATING_1,
                RATING_CHART_COLOR.RATING_2,
                RATING_CHART_COLOR.RATING_3,
                RATING_CHART_COLOR.RATING_4,
                RATING_CHART_COLOR.RATING_5
              ],
              borderWidth: 5,
              data: this.chartData
            }
          ]
        },
        this.options
      );
    },
    setChartData() {
      const ratings = this.ratingDistribution;
      this.chartData = [
        ratings["1"].count,
        ratings["2"].count,
        ratings["3"].count,
        ratings["4"].count,
        ratings["5"].count
      ];
    }
  }
};
